import ccmi_logo from "../assets/ccmi_logo.webp"
import ccmi_logo_mobile from "../assets/ccmi-logo-mobile.svg"
import open from "../assets/open-dropdown.svg"
import close from "../assets/close-dropdown.svg"
import ColourBar from "../components/ColourBar";
import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import auth from "../api/auth";
import burger_open from "../assets/mobile-burger-menu.svg"
import burger_close from "../assets/mobile-burger-close.svg"
import expandable_open from "../assets/mobile-menu-expandable-open.svg"
import expandable_close from "../assets/mobile-menu-expandable-close.svg"


const HomeHeader = () => {

    const navigate = useNavigate();
    const [perillMenuOpen, setPerillMenuOpen] = useState(false)
    const [ccmiMenuOpen, setCcmiMenuOpen] = useState(false)

    const [burgerMenuOpen, setBurgerMenuOpen] = useState(false)

    const togglePerillMenu = (ev) => {
        if (!ev) return;
        setCcmiMenuOpen(false)
        setPerillMenuOpen(!perillMenuOpen)
    }
    const toggleCCMIMenu = (ev) => {
        if(!ev) return;
        setPerillMenuOpen(false)
        setCcmiMenuOpen(!ccmiMenuOpen)
    }

    const handleItemClick =(ev) => {
        const id = ev.currentTarget.id;
        if (!id) return;

        switch (ev.target.id) {
            case "PERILL":
                navigate("/what-is-the-perill-model")
                break;
            case "HIW":
                navigate("/perill-how-it-works")
                break;
            case "Resources":
                navigate("/perill-resources")
                break;
            case "About":
                navigate("/about-ccmi")
                break;
            case "Training":
                navigate("/team-coaching")
                break;
            case "aBooks":
                console.log("books")
                window.open("https://clutterbuck-cmi.com/books/?filter_terms=team-coaching", "_blank", "noopener,noreferrer");
                break;
        }
        setPerillMenuOpen(false);
    }

    const menuNavigate = (path) => {
        navigate(path);
        setBurgerMenuOpen(false)
    }

    return (
        <>
            <div className="home-header-container">
                <ColourBar/>
                <div className="home-header-contents">
                    <Link to="/" className="home-header-logo-container">
                        <img src={ccmi_logo} alt="CCMI"/>
                    </Link>
                    <div className="home-header-navbar no-select">
                        <div className="home-header-navbar-item">
                            <div className="home-header-navbar-item-title" onClick={togglePerillMenu}>About PERILL</div>
                            <div className="home-header-navbar-dropdown-image-container" onClick={togglePerillMenu}>
                                <img src={perillMenuOpen ? close : open} alt={perillMenuOpen ? "Close" : "Open"}/>
                            </div>
                            {perillMenuOpen ?
                                <div className="home-header-navbar-dropwdown-menu" onClick={togglePerillMenu}>
                                    <div className="home-header-navbar-dropwdown-menu-triangle-outer">
                                        <div className="home-header-navbar-dropwdown-menu-triangle-inner"/>
                                    </div>
                                    <div className="home-header-navbar-dropdown-item" id={"PERILL"}
                                         onClick={handleItemClick}>
                                        What is PERILL
                                    </div>
                                    <div className="home-header-navbar-dropdown-item" id={"HIW"}
                                         onClick={handleItemClick}>
                                        How it works
                                    </div>
                                    <div className="home-header-navbar-dropdown-item" id={"Resources"}
                                         onClick={handleItemClick}>
                                        PERILL Resources
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                        <div className="home-header-navbar-item">
                            <div className="home-header-navbar-item-title" onClick={toggleCCMIMenu}>About CCMI</div>
                            <div className="home-header-navbar-dropdown-image-container" onClick={toggleCCMIMenu}>
                                <img src={ccmiMenuOpen ? close : open} alt={ccmiMenuOpen ? "Close" : "Open"}/>
                            </div>
                            {ccmiMenuOpen ?
                                <div className="home-header-navbar-dropwdown-menu" onClick={toggleCCMIMenu}>
                                    <div className="home-header-navbar-dropwdown-menu-triangle-outer">
                                        <div className="home-header-navbar-dropwdown-menu-triangle-inner"/>
                                    </div>
                                    <div className="home-header-navbar-dropdown-item" id={"About"}
                                         onClick={handleItemClick}>
                                        About Us
                                    </div>
                                    <div className="home-header-navbar-dropdown-item" id={"Training"}
                                         onClick={handleItemClick}>
                                        Team Coach Training
                                    </div>
                                    <a
                                        href="https://clutterbuck-cmi.com/books/?filter_terms=team-coaching"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="home-header-navbar-dropdown-item"
                                    >
                                        <div className="home-header-navbar-dropdown-item-text">Team Coaching Books</div>
                                    </a>
                                </div>
                                : null
                            }
                        </div>
                        <div className="home-header-navbar-item">
                            <Link to="/pricing-plans"
                                  className="home-header-navbar-item-title undecorated">Pricing</Link>
                        </div>
                        <div className="home-header-navbar-item undecorated"
                             onClick={() => auth.protectedNavigate("/dashboard", "/register")}>
                            <div className="home-header-navbar-item-title">Sign Up</div>
                        </div>
                        <div className="home-header-navbar-item undecorated"
                             onClick={() => auth.protectedNavigate("/dashboard", "/login")}>
                            <div className="home-header-navbar-item-title">My Account</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`home-header-container-mobile ${burgerMenuOpen ? "burger" : ""}`}>
                <ColourBar/>
                <div className="home-header-container-mobile-body">
                    <Link to="/" className="home-header-logo-container-mobile">
                        <img src={ccmi_logo_mobile} alt="CCMI"/>
                    </Link>
                    <img src={burgerMenuOpen ? burger_close : burger_open}
                         alt={burgerMenuOpen ? "Close menu" : "Open menu"}
                         onClick={() => setBurgerMenuOpen(!burgerMenuOpen)}
                    />
                </div>
                {burgerMenuOpen ?
                    <div className="burger-menu-body">
                        <>
                            <div className="perill-menu-divider-mobile no-top"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className={`perill-menu-expandable-item main ${perillMenuOpen ? "open" : ""}`}>
                                    About PERILL
                                </div>
                                <img src={perillMenuOpen ? expandable_close : expandable_open}
                                     alt={perillMenuOpen ? "Close dropdown" : "Open dropdown"}
                                     onClick={togglePerillMenu}
                                />
                            </div>
                            {perillMenuOpen ?
                                <div className="perill-menu-expandable-item-container">
                                    <div className="perill-menu-expandable-item"
                                         onClick={() => menuNavigate("/what-is-the-perill-model")}>
                                        What is PERILL
                                    </div>
                                    <div className="perill-menu-expandable-item"
                                         onClick={() => menuNavigate("/perill-how-it-works")}>
                                        How it works
                                    </div>
                                    <div className="perill-menu-expandable-item"
                                         onClick={() => menuNavigate("/perill-resources")}>
                                        PERILL Resources
                                    </div>
                                </div> : null
                            }
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className={`perill-menu-expandable-item main ${ccmiMenuOpen ? "open" : ""}`}>
                                    About CCMI
                                </div>
                                <img src={ccmiMenuOpen ? expandable_close : expandable_open}
                                     alt={ccmiMenuOpen ? "Close dropdown" : "Open dropdown"}
                                     onClick={toggleCCMIMenu}
                                />
                            </div>
                            {ccmiMenuOpen ?
                                <div className="perill-menu-expandable-item-container">
                                    <div className="perill-menu-expandable-item"
                                         onClick={() => menuNavigate("/about-ccmi")}>
                                        About Us
                                    </div>
                                    <div className="perill-menu-expandable-item"
                                         onClick={() => menuNavigate("/team-coaching")}>
                                        Team Coach Training
                                    </div>
                                    <div className="perill-menu-expandable-item" id={"Books"}
                                         onClick={() => {handleItemClick()}}>
                                        Team Coaching Books
                                    </div>
                                </div> : null
                            }
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => menuNavigate("/pricing-plans")}>
                                    Pricing
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => {
                                         auth.protectedNavigate("/dashboard", "/register");
                                         setBurgerMenuOpen(false);
                                     }}>
                                    Sign Up
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => {
                                         auth.protectedNavigate("/dashboard", "/login")
                                         setBurgerMenuOpen(false);
                                     }}>
                                    My Account
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-sign-in-button bold" onClick={() => menuNavigate("/login")}>
                                SIGN IN
                            </div>
                            <div className="perill-menu-privacy-policy-link bold"
                                 onClick={() => menuNavigate("/privacy")}>
                                PRIVACY POLICY
                            </div>
                        </>
                    </div> : null
                }
            </div>
        </>
    )
}

export default HomeHeader